/**
 * Lets components outside DevToolsOverlay's own tree (e.g. the user-menu
 * "Dev Tools" item) trigger it open, without lifting its state into a shared
 * context. DevToolsOverlay listens for this event alongside its keyboard
 * shortcut.
 */
const OPEN_EVENT = "sc:dev-tools-overlay:open";

export type DevToolsOverlayTab = "builder" | "settings";

export const openDevToolsOverlay = (tab?: DevToolsOverlayTab): void => {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { tab } }));
};

export const DEV_TOOLS_OVERLAY_OPEN_EVENT = OPEN_EVENT;
